import { Component, OnInit } from '@angular/core';
import { ModalContent, ModalRef } from '../../../modal-ref';
import { ITournament } from '../../../../../page/tournaments/tournaments.interface';

@Component({
    selector: 'app-tournament-leaders-modal',
    templateUrl: './tournament-leaders-modal.component.html',
    styleUrls: ['./tournament-leaders-modal.component.scss'],
    imports: [],
})
export class TournamentLeadersModalComponent implements OnInit, ModalContent {

  public modal: ModalRef;

  constructor() {
  }

  get tournament(): ITournament {
    return this.modal.options.data;
  }

  ngOnInit(): void {
  }

}
